import * as React from 'react';
import { noop } from 'lodash';
import { ContainerPusher } from './styled';

export interface PusherProvided {
    onOpen: () => void;
    onClose: () => void;
}

const PusherContext = React.createContext<PusherProvided>({ onOpen: noop, onClose: noop });
export const PusherConsumer = PusherContext.Consumer;

interface SidebarPusherState {
    isOpen: boolean;
}

interface SidebarPusherProps {
    children: React.ReactNode;
    className?: string;
}

export default class SidebarPusher extends React.Component<SidebarPusherProps, SidebarPusherState> {
    state = {
        isOpen: false,
    };

    handleOpen = () => {
        this.setState({
            isOpen: true,
        });
    };

    handleClose = () => {
        this.setState({
            isOpen: false,
        });
    };

    render() {
        const { children, className } = this.props;
        const { isOpen } = this.state;

        return (
            <PusherContext.Provider value={{ onOpen: this.handleOpen, onClose: this.handleClose }}>
                <ContainerPusher className={className} isOpen={isOpen}>
                    {children}
                </ContainerPusher>
            </PusherContext.Provider>
        );
    }
}
